module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-37-min.5b4e971e.jpg";